class ArticleAd extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.dataset.productHandle;
    this.articleHandle = location.pathname
      .split("/")
      .filter((item) => item.length)
      .pop();
    this.campaign = this.dataset.campaign;

    if (this.productHandle) {
      this.loadAd();
    }
  }

  loadAd() {
    fetch(`/products/${this.productHandle}?view=ad`, { ...{ method: "GET" } })
      .then((response) => {
        if (response.status == 404) return;

        return response.text();
      })
      .then((res) => {
        if (!res) return;

        this.innerHTML = res;
        const href = this.querySelector("a").href;
        Array.from(this.querySelectorAll("a")).forEach(
          (link) =>
            (link.href = `${href}`)
        );
      });
  }
}

customElements.define("article-ad", ArticleAd);
